import React from 'react';
import './Quiz.css';

const Entrance = ({ onStart }) => {
  return (
    <div className="entrance-container">
      <div className="entrance-panels">
        <div className="entrance-content">
          <h1 className="entrance-title">Let's bust some myths on vaping.</h1>
          <p className="entrance-subtitle">Find out how much you know.</p>
          <button onClick={onStart} className="start-button">
            Start now
          </button>
          <div className="entrance-footer">
            <p className="strong mt-16">Not ready?</p>
            <p> <a href="https://vapingfacts.health.nz/the-facts-of-vaping" target="_blank">Read up on the facts first.</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Entrance;
